<template>
    <nav id="nav-bar" class="d-flex">
        <h1><a href="/" class="logo"></a></h1>
        <!--        <a href="/faqs" class="help-button">
            <img src="/themes/ito/images/icon-help.svg" alt="">{{$t('help')}}
        </a>-->
        <div class="menu-item select-lang" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#selectLangModal" style="position: absolute; right: 175px;">
            <img class="flag" :src="selectedLocale?.img_flag" alt="" />
        </div>
        <!-- <a href="/faqs" class="help-button"><img src="/themes/ito/images/icon-help.svg" alt="" style="margin-right: 15px">{{$t('help')}}</a> -->
    </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import { getConfigs, getLanguage } from "../utils/utils";

export default {
    name: "NavBarAuth",

    data() {
        const configs = getConfigs();
        const lang = getLanguage();
        const selectedLocale = configs.localize?.find(locale => locale.lang === lang)
        return {
            user: { name: 'Guest' },
            lang,
            selectedLocale
        };
    },

    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return this.user
        })
    },
    mounted() {
        if (this.lang == 'vi') {
            $.datepicker.setDefaults($.datepicker.regional['vi']);
        } else {
            $.datepicker.setDefaults($.datepicker.regional['']);
        }
    }
}
</script>

<style scoped>
#nav-bar {
    justify-content: space-between;
    align-items: center;
}

.help-button {
    background: linear-gradient(180deg, #20C997 0%, #28A745 100%);
    color: #ffffff;
    width: 130px;
    height: 40px;
    line-height: 40px;
    border-radius: 20px;
    text-align: center;
    box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.07), inset 0px 4px 0px rgba(231, 231, 231, 0.25);
    margin-right: 20px;
}
</style>